import * as React from 'react';
import { Button, Radio, Space, Tag, Tooltip } from '@cloud/atom-ui';
//@ts-ignore
import '../style.m.less';
import * as nls from '../nls';
import { Collection } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { useState, useEffect, memo } from 'react';
//@ts-ignore
import { i18n } from '@src/utils/i18n';

const I18N = i18n(nls);
const t = (key) => {
  return I18N[key];
};
const LENGTH_ADAPTATION_OFFSET = 15;
const SELECTAREA_LINEHIGHT = 30;
const MAX_AREA_HEIGHT = 170;
const MAX_NAME_LENGTH = 20;
const TAG_OFFSET = 40;
const MODAL_WIDTH = 550;
const LEFTOVER = 15;

const SelectMainPage = (props) => {
  const {
    onChange,
    mode,
    setSelectPersonVisible,
    selectedList,
    setSelectedList,
    handleTagClose,
    useModal,
    mainPageSetting,
    mainLoading,
    handleMainOk,
    handleMainCancel,
    showAllEmployees
  } = props;
  const { showAreaMaxWidth = MODAL_WIDTH } = mainPageSetting;
  const [dataList, setDataList] = useState([]);
  const maxAreaWidth = useModal ? MODAL_WIDTH : showAreaMaxWidth;

  // 配合collection实现虚拟滚动的工具函数 计算元素放置的位置
  useEffect(() => {
    let tmpDataList = [];
    let long = selectedList.length;
    let row = 0;
    let offset = 0;
    for (let i = 0; i < long; i++) {
      let tmpName =
        selectedList[i].title.length > MAX_NAME_LENGTH
          ? `${selectedList[i].title.slice(0, MAX_NAME_LENGTH)}...`
          : selectedList[i].title;
      let tmpWidth = getTextWidth(tmpName, 'normal 12px Microsoft YaHei') + TAG_OFFSET;
      if (offset + tmpWidth > maxAreaWidth - LEFTOVER - LENGTH_ADAPTATION_OFFSET) {
        row++;
        offset = 0;
      }
      tmpDataList.push({
        name: selectedList[i].title,
        x: offset,
        y: row * SELECTAREA_LINEHIGHT,
        width: tmpWidth,
        height: SELECTAREA_LINEHIGHT,
        info: selectedList[i],
      });
      offset += tmpWidth;
    }
    setDataList([...tmpDataList]);
  }, [maxAreaWidth, selectedList]);

  function cellRenderer({ index, key, style }) {
    let tag = dataList[index];
    const isLongTag = tag.name.length > MAX_NAME_LENGTH;
    const tagElem = tag.name !== '' && (
      <Tag
        visible={true}
        className="edit-tag"
        key={index}
        closable={true}
        onClose={() => handleTagClose(tag)}
        style={{ marginTop: '4px' }}
      >
        <span style={{ userSelect: 'none' }}>{isLongTag ? `${tag.name.slice(0, MAX_NAME_LENGTH)}...` : tag.name}</span>
      </Tag>
    );
    return (
      <div style={style} key={key}>
        {isLongTag ? (
          <Tooltip title={tag.name} key={index}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        )}
      </div>
    );
  }

  function cellSizeAndPositionGetter({ index }) {
    const datum = dataList[index];

    return {
      height: datum.height,
      width: datum.width,
      x: datum.x,
      y: datum.y,
    };
  }

  // 位于底部的选择提示文本
  const SelectTips = React.memo(() => {
    return (
      <div style={{ marginTop: '20px', maxWidth: maxAreaWidth }}>
        <div style={{ fontSize: 14, color: '#666666' }}>{t('Tips')}</div>
        <div style={{ fontSize: 12, color: '#999999' }}>{t('SelectTips1')}</div>
        <div style={{ fontSize: 12, color: '#999999' }}>{t('SelectTips2')}</div>
      </div>
    );
  });

  // 全体或部分选择
  const ChooseSelectModeRadioGroup = React.memo(() => {
    return (
      <Radio.Group onChange={onChange} value={mode} size={'small'}>
        {mainPageSetting.ifVertical ? (
          <>
            {
              showAllEmployees && (
                <Radio style={{ display: 'block', height: '30px' }} value={'AllCanSee'}>
                  {t('Allemployees')}
                </Radio>
              )
            }

            <Radio
              style={{
                display: 'block',
                height: '30px',
                marginTop: mainPageSetting.distenBetween,
              }}
              value={'SomeCanSee'}
            >
              {t('Someemployees')}
            </Radio>
          </>
        ) : (
          <>
            <Radio value={'AllCanSee'}>{t('Allemployees')}</Radio>
            <Radio style={{ marginLeft: mainPageSetting.distenBetween }} value={'SomeCanSee'}>
              {t('Someemployees')}
            </Radio>
          </>
        )}
      </Radio.Group>
    );
  });

  // 功能按钮组
  const FucButtonGroup = React.memo(() => {
    return (
      // @ts-ignore
      <Space size={'middle'} style={{ marginTop: '12px' }}>
        <Button
          type="default"
          style={{ height: '33px' }}
          size={'small'}
          disabled={mode !== 'SomeCanSee'}
          onClick={() => setSelectPersonVisible(true)}
        >
          {t('SelectPerson')}
        </Button>
        <Button
          type="default"
          style={{ height: '33px' }}
          size={'small'}
          id="downloadNameList"
          disabled={selectedList.length === 0 || mode !== 'SomeCanSee'}
          onClick={() => {
            setSelectedList([]);
          }}
        >
          {t('ClearSelected')}
        </Button>
      </Space>
    );
  });

  // 确认与取消按钮组
  const ConfirmButtonGroup = React.memo(() => {
    return (
      //@ts-ignore
      <Space size={'middle'} style={{ marginTop: '12px' }}>
        <Button
          type="primary"
          size={'small'}
          style={{ height: '33px', width: '80px' }}
          loading={mainLoading}
          onClick={(e) => handleMainOk(e)}
        >
          {t('Confirm')}
        </Button>
        <Button
          key="Cancel"
          size={'small'}
          style={{ height: '33px', width: '80px' }}
          onClick={(e) => handleMainCancel(e)}
        >
          {t('Cancel')}
        </Button>
      </Space>
    );
  });

  return (
    <div className={"ModalContainer"}>
      {mainPageSetting.useChooseModeRadio && <ChooseSelectModeRadioGroup />}

      {(useModal || mode === 'SomeCanSee') && (
        <>
          {/* 多功能按钮 */}
          {mainPageSetting.useFucButtonGroup && <FucButtonGroup />}

          {/* 标签选择展示区域 */}
          {mainPageSetting.useDisplayArea && (
            <div
              className={'selectTagArea'}
              style={
                mode === 'AllCanSee'
                  ? { backgroundColor: '#f5f5f5', pointerEvents: 'none', maxWidth: maxAreaWidth }
                  : { maxWidth: maxAreaWidth }
              }
            >
              <Collection
                cellCount={dataList.length}
                cellRenderer={cellRenderer}
                cellSizeAndPositionGetter={cellSizeAndPositionGetter}
                height={MAX_AREA_HEIGHT}
                width={maxAreaWidth - LEFTOVER}
              />
            </div>
          )}

          {/* 底部提示信息 */}
          {mode === 'SomeCanSee' && mainPageSetting.useSelectTips && <SelectTips />}
        </>
      )}
      {!useModal && mainPageSetting.useConfirmButtonGroup && <ConfirmButtonGroup />}
    </div>
  );
};

// 计算tag标签内文字的长度
const getTextWidth: any = (text, font) => {
  // if given, use cached canvas for better performance
  // else, create new canvas
  let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  let context = canvas.getContext('2d');
  context.font = font;
  let metrics = context.measureText(text);
  return Math.ceil(metrics.width);
};

function areEqual(prevProps, nextProps) {
  if (
    prevProps.selectedList === nextProps.selectedList &&
    prevProps.mode === nextProps.mode &&
    prevProps.mainPageSetting === nextProps.mainPageSetting
  ) {
    return true;
  } else {
    return false;
  }
}

export default memo(SelectMainPage, areEqual);
